module.exports = __webpack_public_path__ + "images/emoji/orange_book.dae6b9f6612c65cd8a9d.png";